/**
 * en-GB messages added by Phase 4 task S41B (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s41bEnGB = {
    // Payment reminder (fixed template billing.invoice_reminder)
    'email.billing.invoice_reminder.subject': '{tenant}: invoice {number} is overdue',
    'email.billing.invoice_reminder.body': 'Invoice {number} for {amount} was due on {dueOn} and is now {days} days overdue. If you have already paid, thank you, and please ignore this reminder. Otherwise please arrange payment as soon as you can.',
    'email.billing.invoice_reminder.button': 'Open billing',
    // Account restricted (fixed template billing.account_restricted)
    'email.billing.account_restricted.subject': '{tenant}: your CloudSign account has overdue invoices',
    'email.billing.account_restricted.body': 'Your account has an invoice that is well past its due date. Sign-in on your kiosks carries on for {graceDays} days. After that, the portal becomes read-only until the invoice is paid. No data is deleted, and evacuations always keep working.',
    'email.billing.account_restricted.button': 'Open billing',
    'billing.error.export_range': 'The start date must not be after the end date.',
};
//# sourceMappingURL=s41b.js.map